// Central API helper for Russian Education
// All calls must be prefixed with /api and use REACT_APP_BACKEND_URL.

const BASE = process.env.REACT_APP_BACKEND_URL;

/**
 * Submit an inquiry to the backend.
 * @param {object} payload - { type, name, phone, email?, message?, city?, neet?, date?, slot?, topic?, variant?, consent? }
 * @returns {Promise<object>} created inquiry
 */
export async function submitInquiry(payload) {
  const res = await fetch(`${BASE}/api/inquiries`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    let detail = 'Unable to submit right now';
    try {
      const body = await res.json();
      if (body?.detail) detail = typeof body.detail === 'string' ? body.detail : JSON.stringify(body.detail);
    } catch (_) { /* ignore */ }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return res.json();
}
